import React from 'react';

interface VisualAcuityProps {
  data: {
    sc_od: string;
    sc_oi: string;
    cc_od: string;
    cc_oi: string;
    near_vision: string;
    pinhole_improves: string;
  };
  onChange: (field: string, value: any) => void;
}

const NEAR_VISION_OPTIONS = [
  { value: '', label: 'Seleccionar...' },
  { value: 'conservada', label: 'Conservada' },
  { value: 'disminuida', label: 'Disminuida' },
];

const PINHOLE_OPTIONS = [
  { value: '', label: 'Seleccionar...' },
  { value: 'si', label: 'Sí' },
  { value: 'no', label: 'No' },
  { value: 'no aplica', label: 'No Aplica' },
];

const VisualAcuity: React.FC<VisualAcuityProps> = ({ data, onChange }) => {
  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">
          <i className="fa fa-eye me-1"></i>
          Agudeza Visual
        </h5>
        <div className="row mt-3">
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">SC Ojo Derecho (20/XX)</label>
              <input
                type="text"
                className="form-control"
                value={data.sc_od}
                onChange={e => onChange('sc_od', e.target.value)}
                placeholder="Ej: 20/20, 20/40"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">SC Ojo Izquierdo (20/XX)</label>
              <input
                type="text"
                className="form-control"
                value={data.sc_oi}
                onChange={e => onChange('sc_oi', e.target.value)}
                placeholder="Ej: 20/20, 20/40"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Visión Cercana</label>
              <select
                className="form-select"
                value={data.near_vision}
                onChange={e => onChange('near_vision', e.target.value)}
              >
                {NEAR_VISION_OPTIONS.map(o => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">CC Ojo Derecho (20/XX)</label>
              <input
                type="text"
                className="form-control"
                value={data.cc_od}
                onChange={e => onChange('cc_od', e.target.value)}
                placeholder="Ej: 20/20, 20/30"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">CC Ojo Izquierdo (20/XX)</label>
              <input
                type="text"
                className="form-control"
                value={data.cc_oi}
                onChange={e => onChange('cc_oi', e.target.value)}
                placeholder="Ej: 20/20, 20/30"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Mejora con Agujero Estenopeico</label>
              <select
                className="form-select"
                value={data.pinhole_improves}
                onChange={e => onChange('pinhole_improves', e.target.value)}
              >
                {PINHOLE_OPTIONS.map(o => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisualAcuity;
